export const createKeybyTimestamp = () => {
  return new Date().getTime().toString();
};

// now we use localStorage because sessionStorage will be lost in some case

export const upsertObject = (key, object) => {
  if (!object) {
    return;
  }

  localStorage.setItem(key, JSON.stringify(object));
};

export const getObject = (key) => {
  const string = localStorage.getItem(key);

  if (!string) {
    return undefined;
  }

  return JSON.parse(string);
};

export const validateSessionkey = (key) => {
  const {
    selectedOutboundFlight, selectedInboundFlight, searchedFlightsInput,
  } = getFlightState(key);
  const { searchedHotelsInput } = getHotelState(key);
  return !!(selectedOutboundFlight && selectedInboundFlight && searchedFlightsInput && searchedHotelsInput);
};

export const duplicateSessionValue = (key) => {
  const value = getObject(key);
  const newKey = createKeybyTimestamp();
  upsertObject(newKey, value);
  return newKey;
};

export const getFlightState = (key) => {
  const state = getObject(key) || {};
  const flight = state.flight || {};
  return flight;
};

export const getHotelState = (key) => {
  const state = getObject(key) || {};
  const hotel = state.hotel || {};
  return hotel;
};

export const getPlanDetailState = (key) => {
  const state = getObject(key) || {};
  const planDetail = state.planDetail || {};
  return planDetail;
};

export const saveSearchedFlightsInput = (key, searchedFlightsInput) => {
  const state = getObject(key) || {};
  const flight = state.flight || {};
  flight.searchedFlightsInput = searchedFlightsInput;
  const newState = {
    ...state,
    flight,
  };

  return upsertObject(key, newState);
};

export const saveSearchedHotelsInput = (key, searchedHotelsInput) => {
  const state = getObject(key) || {};
  const hotel = state.hotel || {};
  hotel.searchedHotelsInput = searchedHotelsInput;
  const newState = {
    ...state,
    hotel,
  };

  return upsertObject(key, newState);
};

export const saveSelectedOutboundFlight = (key, selectedOutboundFlight) => {
  const state = getObject(key) || {};
  const flight = state.flight || {};
  flight.selectedOutboundFlight = selectedOutboundFlight;
  const newState = {
    ...state,
    flight,
  };

  return upsertObject(key, newState);
};

export const saveSelectedInboundFlight = (key, selectedInboundFlight) => {
  const state = getObject(key) || {};
  const flight = state.flight || {};
  flight.selectedInboundFlight = selectedInboundFlight;
  const newState = {
    ...state,
    flight,
  };

  return upsertObject(key, newState);
};

export const saveSelectedOutboundDate = (key, selectedOutboundDate) => {
  const state = getObject(key) || {};
  const flight = state.flight || {};
  flight.selectedOutboundDate = selectedOutboundDate;
  const newState = {
    ...state,
    flight,
  };

  return upsertObject(key, newState);
};

export const saveSelectedInboundDate = (key, selectedInboundDate) => {
  const state = getObject(key) || {};
  const flight = state.flight || {};
  flight.selectedInboundDate = selectedInboundDate;
  const newState = {
    ...state,
    flight,
  };

  return upsertObject(key, newState);
};


export const saveSelectedPlans = (key, plans) => {
  const state = getObject(key) || {};
  const planDetail = state.planDetail || {};
  planDetail.plans = plans;
  const newState = {
    ...state,
    planDetail,
  };

  return upsertObject(key, newState);
};

const sessionIdKey = 'si';

export const getSessionId = () => {
  return localStorage.getItem(sessionIdKey);
};

export const saveSessionId = (sessionToken) => {
  localStorage.setItem(sessionIdKey, sessionToken);
};
